/**
 * A FIFO structure with unique elements and O(1) operations
 */
export class QueueSet<T> {
  private readonly queue = new Set<T>();

  enqueue(element: T) {
    if (this.queue.has(element)) {
      this.queue.delete(element);
    }
    this.queue.add(element);
  }

  dequeue(): T | undefined {
    if (this.queue.size === 0) return undefined;
    const front = this.queue.values().next().value!;
    this.queue.delete(front);
    return front;
  }

  has(element: T): boolean {
    return this.queue.has(element);
  }

  length(): number {
    return this.queue.size;
  }

  values(): SetIterator<T> {
    return this.queue.values();
  }

  *dequeueMany(count: number): Iterable<T> {
    const initialLength = this.length();
    for (let i = 0; i < Math.min(initialLength, count); i++) {
      yield this.dequeue()!;
    }
  }
}
